import { useMutation } from '@tanstack/react-query';
import { gettingStartedApi, type ModuleSourceBundleResult } from '../api/gettingStartedApi';
import type { ApiError } from '../../common-showcase/types/showcase';

/**
 * Mutation: POST /api/eraf/catalog/module-source-bundles (queue #641)
 * 성공 시 blob+filename 을 반환 — 호출부(CurationBundlePicker)가 브라우저 다운로드를 트리거한다.
 */
export function useModuleSourceBundle() {
  return useMutation<ModuleSourceBundleResult, ApiError, string[]>({
    mutationFn: (codes) => gettingStartedApi.exportModuleSourceBundle(codes),
    mutationKey: ['getting-started-guide', 'module-source-bundle'],
  });
}
